import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import chatReducer from './slices/chatSlice';
import uiReducer from './slices/uiSlice';
import artifactReducer from './slices/artifactSlice';

import pipelineReducer from './slices/pipelineSlice';
import monitoringReducer from './slices/monitoringSlice';
import knowledgeReducer from './slices/knowledgeSlice';
import rulesReducer from './slices/rulesSlice';
import connectorsReducer from './slices/connectorsSlice';
import jobsReducer from './slices/jobsSlice';
import qcReducer from './slices/qcSlice';
import { authApi } from './api/authApi';
import { conversationApi } from './api/conversationApi';
import { feedbackApi } from './api/feedbackApi';
import { studioApi } from './api/studioApi';
import { pipelineApi } from './api/pipelineApi';
import { rulesApi } from './api/rulesApi';
import { knowledgeApi } from './api/knowledgeApi';
import { connectorsApi } from './api/connectorsApi';
import { actionsApi } from './api/actionsApi';
import { monitoringApi } from './api/monitoringApi';
import { healthApi } from './api/healthApi';
import { microagentApi } from './api/microagentApi';
import { toolsApi } from './api/toolsApi';
import { datalakeApi } from './api/datalakeApi';
import { jobsApi } from './api/jobsApi';
import { projectsApi } from './api/projectsApi';
import { departmentsApi } from './api/departmentsApi';
import { storageApi } from './api/storageApi';
import { qcApi } from './api/qcApi';
import { webhooksApi } from './api/webhooksApi';
import { schedulesApi } from './api/schedulesApi';
import { skillsApi } from './api/skillsApi';
import { triggersApi } from './api/triggersApi';
import { reviewApi } from './api/reviewApi';
import { notificationsApi } from './api/notificationsApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    chat: chatReducer,
    ui: uiReducer,
    artifact: artifactReducer,

    pipelineUI: pipelineReducer,
    monitoringUI: monitoringReducer,
    knowledgeUI: knowledgeReducer,
    rulesUI: rulesReducer,
    connectorsUI: connectorsReducer,
    jobs: jobsReducer,
    qcUI: qcReducer,
    [authApi.reducerPath]: authApi.reducer,
    [conversationApi.reducerPath]: conversationApi.reducer,
    [feedbackApi.reducerPath]: feedbackApi.reducer,
    [studioApi.reducerPath]: studioApi.reducer,
    [pipelineApi.reducerPath]: pipelineApi.reducer,
    [rulesApi.reducerPath]: rulesApi.reducer,
    [knowledgeApi.reducerPath]: knowledgeApi.reducer,
    [connectorsApi.reducerPath]: connectorsApi.reducer,
    [actionsApi.reducerPath]: actionsApi.reducer,
    [monitoringApi.reducerPath]: monitoringApi.reducer,
    [healthApi.reducerPath]: healthApi.reducer,
    [microagentApi.reducerPath]: microagentApi.reducer,
    [toolsApi.reducerPath]: toolsApi.reducer,
    [datalakeApi.reducerPath]: datalakeApi.reducer,
    [jobsApi.reducerPath]: jobsApi.reducer,
    [projectsApi.reducerPath]: projectsApi.reducer,
    [departmentsApi.reducerPath]: departmentsApi.reducer,
    [storageApi.reducerPath]: storageApi.reducer,
    [qcApi.reducerPath]: qcApi.reducer,
    [webhooksApi.reducerPath]: webhooksApi.reducer,
    [schedulesApi.reducerPath]: schedulesApi.reducer,
    [skillsApi.reducerPath]: skillsApi.reducer,
    [triggersApi.reducerPath]: triggersApi.reducer,
    [reviewApi.reducerPath]: reviewApi.reducer,
    [notificationsApi.reducerPath]: notificationsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(authApi.middleware)
      .concat(conversationApi.middleware)
      .concat(feedbackApi.middleware)
      .concat(studioApi.middleware)
      .concat(pipelineApi.middleware)
      .concat(rulesApi.middleware)
      .concat(knowledgeApi.middleware)
      .concat(connectorsApi.middleware)
      .concat(actionsApi.middleware)
      .concat(monitoringApi.middleware)
      .concat(healthApi.middleware)
      .concat(microagentApi.middleware)
      .concat(toolsApi.middleware)
      .concat(datalakeApi.middleware)
      .concat(jobsApi.middleware)
      .concat(projectsApi.middleware)
      .concat(departmentsApi.middleware)
      .concat(storageApi.middleware)
      .concat(qcApi.middleware)
      .concat(webhooksApi.middleware)
      .concat(schedulesApi.middleware)
      .concat(skillsApi.middleware)
      .concat(triggersApi.middleware)
      .concat(reviewApi.middleware)
      .concat(notificationsApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
